module.exports = __webpack_public_path__ + "static/media/home.1964a643.png";